import { Icon } from '@/components/icons/svg-icons';
import { bettingPreferenceModalStyle } from '../betting-preference-modal.style';
import { useTranslations } from 'next-intl';

export const BetslipBasicImg = ({ active = false }) => {
	const t = useTranslations('General');

	return (
		<>
			<svg xmlns="http://www.w3.org/2000/svg" width="133" height="76" fill="none" viewBox="0 0 133 76">
				<path fill={active ? 'var(--background-primary-500-54, var(--p500-50))' : 'var(--background-utility-constant-black-12, var(--lv2-8))'} d="M8.25 47a6 6 0 0 1 6-6h111a6 6 0 0 1 6 6v21a6 6 0 0 1-6 6h-111a6 6 0 0 1-6-6V47Z" />
				<path fill="var(--background-neutral-400-300, var(--other-lv2))" d="M5.25 43a6 6 0 0 1 6-6h111a6 6 0 0 1 6 6v21a6 6 0 0 1-6 6h-111a6 6 0 0 1-6-6V43Z" />
				<path stroke={active ? 'var(--border-primary-500, var(--p500))' : 'var(--border-utility-inverse-30, var(--lv1-30))'} d="M11.25 37.5h111a5.5 5.5 0 0 1 5.5 5.5v21a5.5 5.5 0 0 1-5.5 5.5h-111a5.5 5.5 0 0 1-5.5-5.5V43a5.5 5.5 0 0 1 5.5-5.5Z" />
				<path stroke="var(--border-utility-inverse-08,var(--lv1-8)) " d="M6.25 55.5h121" />
			</svg>
			<div className={bettingPreferenceModalStyle.betslipTitle}>
				<Icon name="betslip-bet" />
				{t('Betsilp')}
				<span className={bettingPreferenceModalStyle.betslipBadge}>3</span>
			</div>
		</>
	)
};